


































import Vue, { PropType } from 'vue';
import { IABTest, IABTestModalProp } from '@/store/types';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';

export default Vue.extend({
  name: 'ABTestCreateModal',
  data() {
    return {
      saving: false as boolean,
    };
  },
  props: {
    abTest: Object as PropType<IABTestModalProp>,
    show: {
      type: Boolean,
    },
  },
  methods: {
    async confirmCreateABTest() {
      if (this.abTest.segmentId) {
        this.saving = true;
        await this.$store.dispatch(actions.CREATE_AB_TEST, {
          id: this.abTest.segmentId,
          data: {
            name: this.abTest.name,
          },
        });
        this.saving = false;
        this.$emit('close');
      }
    },
  },
});
